export enum ESortColumnValue {
  ASC = 'ascend',
  DESC = 'descend',
}

export const SORT_VALUES = {
  [ESortColumnValue.ASC]: 'ASC',
  [ESortColumnValue.DESC]: 'DESC',
}
